<template>
    <div class="card card-default">
        <div class="card-header">
            Update Team ShortURL Settings
        </div>

        <div class="card-body">
            <!-- Success Message -->
            <div class="alert alert-success" v-if="form.successful">
                Your team details have been updated!
            </div>

            <form role="form">
                <!-- Domain -->
                <div class="form-group row" :class="{'has-error': form.errors.has('domain')}">
                    <label class="col-md-4 col-form-label text-md-right">Domain</label>

                    <div class="col-md-6">
                        <input type="text" class="form-control" name="domain" v-model="form.domain" :class="{'is-invalid': form.errors.has('domain')}">

                        <span class="help-block" v-show="form.errors.has('domain')">
                            {{ form.errors.get('domain') }}
                        </span>
                    </div>
                </div>

                <!-- Update Button -->
                <div class="form-group row mb-0">
                    <div class="offset-md-4 col-md-6">
                        <button type="submit" class="btn btn-primary"
                                @click.prevent="update"
                                :disabled="form.busy">
                            Update
                        </button>
                    </div>
                </div>

                <small class="help-block">
                    <i class="fa fa-info-circle"></i> Give the domain in the form: https://domain.com. Before adding the domain make the appropriate DNS changes and test that work!
                </small>
            </form>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2'

export default {
    props: ['team'],

    data() {
        return {
            form: new SparkForm({
                domain: '',
                handle: '',
            }),
        };
    },

    mounted() {
        this.form.handle = this.team.handle;
        this.form.domain = this.team.domain;

        Bus.$on(`sparkFormUpdated.${this.form.sparkFormId}`, this.$forceUpdate)
    },

    methods: {
        update() {
            if (typeof this.form.domain === 'string' || this.form.domain instanceof String) {
                this.form.domain = this.form.domain.trim().toLowerCase();

                if (this.form.domain.length === 0) {
                    this.form.domain = null;
                }
            }

            if (this.team.domain !== this.form.domain) {
                Swal.fire({
                    title: 'Are you sure?',
                    text: 'If you change the domain, any short URLs to the old domain will cease to function!',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'I am aware, change the domain!',
                }).then(({ value }) => {
                    if (!value) {
                        return;
                    }

                    this.form.domain = this.form.domain.replace('http://', 'https://');

                    if (!this.form.domain.startsWith('https://')) {
                        this.form.domain = 'https://' + this.form.domain;
                    }

                    Spark.put(`/settings/teams/${this.team.id}/name`, this.form).then(
                        () => {
                            Bus.$emit('updateTeam');
                            Bus.$emit('updateTeams');
                        },
                        () => {
                            this.form.domain = this.team.domain;
                        }
                    );
                });
            }
        },
    },
}
</script>
